import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const BlacklistedArtist = ({id, is_blacklisted, tooltipPlacement="top"}) => {
  const { t } = useTranslation();
  const tooltipId = `blacklisted-tooltip-${id}`;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const tooltipText = is_blacklisted
    ? t('artists.view.table.message.artistBlacklisted')
    : t('artists.view.table.message.artistNotBlacklisted');
  const iconColor = is_blacklisted ? 'danger' : 'success';

  return (
    <div 
        key={id}
        id={tooltipId}
        className={`mdi mdi-flag mdi-36px text-${iconColor}`}
        style={{ cursor: 'pointer' }}
    >
      <Tooltip
        placement={tooltipPlacement}
        isOpen={tooltipOpen}
        target={tooltipId}
        toggle={toggle}
      >
        {tooltipText}
      </Tooltip>
    </div>
  );
};

export default BlacklistedArtist;